import s from './ShareEvent.module.scss';

export const InviteEventSummary = () => {
  return (
    <div className={`flex flex-col items-center px-2 py-16 text-center md:py-20 ${s.summary}`}>
      <div className={`text-18 md:text-22 mb-3 font-semibold`}>초대받은 친구가 환급금 조회하면 성공!</div>
      <div className={`${s.title} ${s.naver}`}>네이버페이 포인트</div>
      <div className={s.title}>무제한으로 적립돼요</div>
      <div className={'mt-6 whitespace-pre text-center font-medium'}>
        {'초대 성공하면 나는 네이버페이 포인트를,\n초대받은 친구는 환급 신청 수수료 할인 10%!'}
      </div>
      <div className={'text-15 md:text-17 lg:text-18 mt-8 rounded-full bg-black px-4 py-1.5 font-medium text-white'}>이벤트 기간</div>
      <div className={'mt-2.5 text-center font-medium'}>모든 사장님들이 비즈넵 혜택을 받으실 때까지!</div>
      <img
        className={'mt-8 w-[327px] lg:w-[527px]'}
        src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/summary-promotion.png`}
        alt="summary-promotion"
      />
    </div>
  );
};
